// Mirrors the Mongoose validators on Account.contactEmail and ScheduledReport.email.
// A looser pattern here surfaces as an opaque server error instead of inline feedback.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

export const isValidEmail = (email: string): boolean =>
	EMAIL_REGEX.test(email.trim());
